import React from 'react';
import Hero from './Hero';
import HowItWorks from './HowItWorks';
import Features from './Features';
import IndustriesWeSupport from './IndustriesWeSupport';
import Testimonials from './Testimonial';
import FAQSection from '../Pricing/FAQSection';
import PageLayout from '../PageLayout/PageLayout';

export default function LandingPage() {
  return (
    <div>
      <PageLayout fullBleed>
        <Hero />
        <Features />
        <IndustriesWeSupport />
        <HowItWorks />
        <Testimonials />
        <FAQSection variant="home" />
      </PageLayout>
    </div>
  );
}
